module.exports = __webpack_public_path__ + "static/media/29BDOS17.8578c756.jpg";